import {fetchPut} from "./util";

export const updateUserSetting = (user) => {
    return fetchPut(`/users/settings`, user).then((res) => res);
}